import { render, staticRenderFns } from "./UniversalTreeView.vue?vue&type=template&id=7d96d2ce&scoped=true"
import script from "./UniversalTreeView.vue?vue&type=script&lang=js"
export * from "./UniversalTreeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96d2ce",
  null
  
)

export default component.exports